export default __webpack_public_path__ + "static/media/ic_aspect_ratio_selected.1d948cf2.svg";